import { DocumentsComponent } from "@/features";
import { Deal } from "@/types";

interface Props {
  isLoading: boolean
  deals: Deal[]
  onRefresh?: () => void
  currentDeal: Deal | null
  onDealChange: (deal: Deal) => void
}

export const DocumentsPage = ({ deals, isLoading, onRefresh, currentDeal, onDealChange }: Props) => {
  return <DocumentsComponent deals={deals} isLoading={isLoading} onRefresh={onRefresh} currentDeal={currentDeal} onDealChange={onDealChange} />;
}
